import dayjs from 'dayjs';

export type FilterState = {
  [key: string]: {
    operator?: string;
    value?: any;
    type?:
      | 'char'
      | 'integer'
      | 'float'
      | 'boolean'
      | 'datetime'
      | 'selection'
      | 'carrier'
      | 'country_group'
      | 'country';
  };
};

export const RELATIONAL_FIELDS: Record<string, string> = {
  partner_id: 'partner_id.name',
};

export function buildFiltersDomain(filters: FilterState): any[] {
  return Object.entries(filters)
    .filter(([, v]) => v.operator && v.value !== undefined && v.value !== '')
    .flatMap(([field, v]) => {
      const operator = v.operator!; // non-null assertion
      field = RELATIONAL_FIELDS[field] ?? field;

      const { value } = v;

      switch (v.type) {
        case 'integer':
        case 'carrier':
        case 'country_group':
        case 'country':
          return [[field, operator, Number(value)]];

        case 'float':
          return [[field, operator, parseFloat(value)]];

        case 'boolean':
          return [[field, operator, value === 'True' || value === true ? 1 : 0]];

        case 'datetime': {
          const date = dayjs(value);

          if (v.operator === '=') {
            const startOfDay = date.startOf('day').toISOString();
            const startOfNextDay = date.add(1, 'day').startOf('day').toISOString();

            return [
              [field, '>=', startOfDay],
              [field, '<', startOfNextDay],
            ];
          }

          return [[field, operator, date.toISOString()]];
        }

        default:
          return [[field, operator, String(value)]];
      }
    });
}
